import {IdType} from '../../util/models/IdType'
import {Sorting} from './Sorting'


export interface Search {
    phrase?: SearchPhrase | null,
    technicalClassificationNodeId?: IdType,
    partNumberPhrase?: SearchPhrase | null,
    labelPhrase?: SearchPhrase | null,
    idPhrase?: SearchPhrase | null,
    guildId?: IdType,
    filters?: ApplyFilterDTO[],
    organizationFilter?: ApplyFilterOrgDTO | null,
    sorting?: Sorting
    itemTypeFilter?: ApplyFilterItemTypeDTO | null,
    notDefinedByOrganizationsFilter?: ApplyFilterOrgDTO | null
    visibleByGuildId?: string
    isPublicFilter?: boolean | null
    managedByGuildFilter?: string
    itemListId?: IdType,
    options?: OptionsSearch | null
}

export interface SearchPhrase {
    phraseDetail: string,
    isExact: boolean
}

export interface OptionsSearch {
    itemRetrieveType: string,
}

export enum ItemRetrieveType {
    SUMMARY = 'Summary'
}

export interface ApplyFilterDTO {
    attributeDefinitionId: string,
    values: string[]
}

export interface ApplyFilterOrgDTO {
    organizationIds: string[]
}

export interface ApplyFilterItemTypeDTO {
    itemTypes: string[]
}